'use es6';

import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';

/**
 * Context for callbacks that handle opening the communicator, making updates after object creates,
 * and anything else the host app might care about from changes made within the sidebar
 *
 * @param {object}   value                     the context value
 *
 * @callback onAssociationUpdate
 * @param {String} objectType                  type of the object that had its associations updated
 * @param {String} objectId                    ID of the object that had its associations updated
 * @param {String} associationObjectType       type of the associated objects updated
 *
 * @callback onObjectCreate
 * @param {String} associationType             type of the object created
 * @param {String} objectId                    ID of the object created
 * @param {Boolean} addAnother                  true if the user asked to create another object, otherwise false
 *
 * @callback onObjectDelete
 * @param {String} objectTypeId                type ID of the object deleted
 * @param {String} objectId                    ID of the object deleted
 *
 * @callback onObjectUpdate                    callback that fires when object properties or associations change
 * @param {String} objectType                  type of the object which was updated
 * @param {String} objectId                    ID of the object which was updated
 * @param {Immutable.Map} properties                     optional Map of updated property names to values
 */

export const HostAppCallbacksContext = /*#__PURE__*/createContext({
  onAssociationUpdate: emptyFunction,
  onObjectCreate: emptyFunction,
  onObjectDelete: emptyFunction,
  onObjectUpdate: emptyFunction
});
HostAppCallbacksContext.Provider.propTypes = {
  value: PropTypes.shape({
    onAssociationUpdate: PropTypes.func,
    onObjectCreate: PropTypes.func,
    onObjectDelete: PropTypes.func,
    onObjectUpdate: PropTypes.func
  }).isRequired
};
export const useHostAppCallbacksContext = () => useContext(HostAppCallbacksContext);